autosizeTextareas();
addPremium();
initializeMaps();
truncateText('summary');
